'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function AgentComponent($http, AppConstants) {
	'ngInject';

	var service = {
		'fetchAgents': fetchAgents,
		'fetchAgent': fetchAgent,
		'getAgents': getAgents,
		'getAgent': getAgent,
		'getPaginationInfo': getPaginationInfo,
		'createAgent': createAgent,
		'updateAgent': updateAgent,
		'deleteAgent': deleteAgent
	};

	var agents = [];
	var agent = {};
	// Information for pagination, current_page, total(count of items), and per_page(items on page)
	var paginationInfo = {};

	return service;

	function fetchAgents() {
		var page = arguments.length <= 0 || arguments[0] === undefined ? 1 : arguments[0];
		var sort = arguments.length <= 1 || arguments[1] === undefined ? '-id' : arguments[1];

		return $http.get(AppConstants.apiUrl + '/agents', {
			'params': {
				page: page,
				sort: sort,
				'per_page': AppConstants.perPage
			}
		}).then(setAgents)['catch'](failedRequest);
	}

	function fetchAgent(id) {
		return $http.get(AppConstants.apiUrl + '/agents/' + id).then(setAgent)['catch'](failedRequest);
	}

	function setAgents(response) {
		paginationInfo.page_size = AppConstants.perPage;
		paginationInfo.page = response.data.current_page;
		paginationInfo.total = response.data.total;
		agents = response.data.data;
		return agents;
	}

	function setAgent(response) {
		agent = response.data.data;
		return agent;
	}

	function getAgents() {
		return agents;
	}

	function getAgent() {
		return agent;
	}

	function getPaginationInfo() {
		return paginationInfo;
	}

	function createAgent(params) {
		return $http.post(AppConstants.apiUrl + '/agents', params).then(successRequest)['catch'](failedRequest);
	}

	function updateAgent(id, params) {
		return $http.put(AppConstants.apiUrl + '/agents/' + id, params).then(successRequest)['catch'](failedRequest);
	}

	function deleteAgent(id) {
		return $http['delete'](AppConstants.apiUrl + '/agents/' + id).then(successRequest)['catch'](failedRequest);
	}

	function successRequest(response) {
		return response;
	}

	function failedRequest(requestError) {
		console.log(requestError);
		return requestError;
	}
}
exports['default'] = AgentComponent;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/components/agent/agent.service.js
 **/